import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {ActionsService} from "../../Redux/Actions/actions.service";
import {ApplicationContextActions} from "../../Redux/Actions/application-cotext-actions";
import {Utils} from "../../common/utils";
import {select} from "@angular-redux/store";
import {isNullOrUndefined} from "util";
import {edsEnvConfiguration} from "../../../environments/edsEnvConfiguration";
import {SpecToDesign} from "../../models/SpecToDesign";
import {IAppTypeMap} from "../../models/common";
import {combineLatest, Observable} from "rxjs";
import {filter} from "rxjs/operators";
import {AnalyticsActions} from "../../Redux/Actions/analytics.actions";
import {IeDsFile} from "../../models/user-info";
import {MatSnackBar} from "@angular/material/snack-bar";
import {HttpClient} from "@angular/common/http";
import {AuthService} from "../../auth/auth.service";

@Component({
  selector: 'edsng-parse-from-widget',
  templateUrl: './parse-from-widget.component.html',
  styleUrls: ['./parse-from-widget.component.css']
})
export class ParseFromWidgetComponent implements OnInit {
  static contextMap = {
    dcdc: ['/app', 'dcdc', 'ic_dcdc_catalogs', 'filter', '[]'],
    acdc: ['/app', 'acdc', 'ic_acdc_catalogs', 'filter', '[]'],
    led_dcdc: ['/app', 'led', 'ic_led_catalogs', 'filter', '[]'],
    led_acdc: ['/app', 'led_acdc', 'ic_led_acdc_catalogs', 'filter', '[]'],
    charger: ['/app', 'acdc', 'ic_acdc_catalogs_chargers', 'filter', '[]'],
  };

  @select(["appProjectTypes", "appTypeMap"]) appTypeMap$: Observable<IAppTypeMap>;

  constructor(private act: ActionsService,
              private route: ActivatedRoute,
              private router: Router,
              public  snack: MatSnackBar,
              public  httpAuth: AuthService,
  ) {
    // console.log("ParseFromWidgetComponent", new Date().toISOString());
  }

  handle = null;


  ngOnInit() {
    // console.log("ParseFromWidgetComponent ngOnInit");
    // Observable.combineLatest(this.route.params, this.route.queryParams).subscribe(
    this.handle = combineLatest([this.appTypeMap$.pipe(filter((x) => x != null)), this.route.queryParams]).subscribe(([x, y]) => {
      setTimeout(() => {
        this.handle.unsubscribe();
        const _appType = Utils.getFieldValue(y, 'context');
        const _fileId = Utils.getFieldValue(y, 'open_file');
        const _inFrame = Utils.getFieldValue(y, 'frame') || this.inIframe();
        if (_appType !== null) {
          const _routing = Utils.getFieldValue(ParseFromWidgetComponent.contextMap, _appType);
          // console.log("Routing", _routing);
          if (_routing !== null) {
            const _selecIc = Utils.getFieldValue(y, 'selected');
            if (_selecIc) {
              _routing.push('selected');
              _routing.push(_selecIc);
            }
            this.act.sendAction(ApplicationContextActions.setContext(y));
            if (_inFrame) {
              // set context frame mode
              this.act.sendAction(ApplicationContextActions.setFrameMode(_inFrame ? true : false));
            }
            this.router.navigate(_routing);
          } else {
            const redirect = this.getApplicationUrl(x, _appType);
            if (redirect !== '') {
              // this.route.snapshot.queryParams
              const params = new URLSearchParams();
              Object.keys(y).filter(k => k !== 'context').forEach((key) => params.set(key, y[key]));
              const fullRedirect = redirect + '?' + params.toString();
              window.open(fullRedirect, '_self');
            } else {
              // other redirect param
              this.router.navigate(["/home"]);
            }
          }
        } else if (_fileId) { // open file id
          // const handleWnd = window.open();            // To avoid pop-up blocking window
          const f: IeDsFile = {id: _fileId, label: "", creationDate: "", isFolder: false, description: "", path: ""};
          SpecToDesign.openUserProject(
            this.httpAuth,
            f,
            x
          ).subscribe(
            (fa) => {
              this.act.sendAction(AnalyticsActions.sendAnalyticsEvent(
                'open_user_file',
                'project',
                {details: 'id=' + _fileId, tag: "widget", module: "home"}));

              window.location.href = fa.base + fa.app + "?msg=" + encodeURIComponent(fa.msg);    // To avoid pop-up blocking window
              // handleWnd.location.href = edsEnvConfiguration.login_url + encodeURIComponent(fa.base + fa.app + "?msg=" + fa.msg);    // login

              // console.log("openUserProject ", f);
            },
            (err) => {
              const errMsg = "Open User file from widget " + f.label + " [" + f.id + "]" + ' - Error:' + err;
              this.act.sendAction(AnalyticsActions.sendAnalyticsException(errMsg));
              this.snack.open(errMsg, 'OK', {duration: 3000});
              this.router.navigate(["/home"]);
            });

        } else {// go to home (context not defined)
          this.router.navigate(["/home"]);
        }
      }, 1);
    });
  }

  inIframe() {
    try {
      return window.self !== window.top;
    } catch (e) {
      return true;
    }
  }
  getApplicationUrl(_map: IAppTypeMap, appName: string): string {
    const _appTypeMap = _map.apps.find(
      x => x.app.name.toLowerCase() === appName.toLowerCase()
    );

    if (isNullOrUndefined(_appTypeMap)) {
      return "";
    } else {
      /* (_appTypeMap.app.url.endsWith('open')) for the antenna and acswitch */
      const base = isNullOrUndefined(_appTypeMap.app.baseUrl) ? edsEnvConfiguration.edsUrl : _appTypeMap.app.baseUrl;
      const app = (_appTypeMap.app.url.endsWith('open')) ? _appTypeMap.app.url.replace(/open$/i, "") : _appTypeMap.app.url;
      return base + app;
    }
  }
}
